module.exports = __webpack_public_path__ + "static/media/t-2-q-4.f545c645.jpg";